module.exports = __webpack_public_path__ + "static/result_pajuh-689a3a94c118369b790fe7d5d21daa53.png";